/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Status_ThinkingInputs */

const en_admin_ai_chat_status_thinking = /** @type {(inputs: Admin_Ai_Chat_Status_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thinking…`)
};

const de_admin_ai_chat_status_thinking = /** @type {(inputs: Admin_Ai_Chat_Status_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denkt nach…`)
};

const es_admin_ai_chat_status_thinking = /** @type {(inputs: Admin_Ai_Chat_Status_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pensando…`)
};

const fr_admin_ai_chat_status_thinking = /** @type {(inputs: Admin_Ai_Chat_Status_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réflexion…`)
};

const nl_admin_ai_chat_status_thinking = /** @type {(inputs: Admin_Ai_Chat_Status_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aan het denken…`)
};

/** @type {(inputs: Admin_Ai_Chat_Status_ThinkingInputs) => LocalizedString} */
const it_admin_ai_chat_status_thinking = en_admin_ai_chat_status_thinking;

/** @type {(inputs: Admin_Ai_Chat_Status_ThinkingInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_status_thinking = en_admin_ai_chat_status_thinking;

/** @type {(inputs: Admin_Ai_Chat_Status_ThinkingInputs) => LocalizedString} */
const pl_admin_ai_chat_status_thinking = en_admin_ai_chat_status_thinking;

/** @type {(inputs: Admin_Ai_Chat_Status_ThinkingInputs) => LocalizedString} */
const hu_admin_ai_chat_status_thinking = en_admin_ai_chat_status_thinking;

/** @type {(inputs: Admin_Ai_Chat_Status_ThinkingInputs) => LocalizedString} */
const ro_admin_ai_chat_status_thinking = en_admin_ai_chat_status_thinking;

/**
* | output |
* | --- |
* | "Thinking…" |
*
* @param {Admin_Ai_Chat_Status_ThinkingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_status_thinking = /** @type {((inputs?: Admin_Ai_Chat_Status_ThinkingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Status_ThinkingInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_status_thinking(inputs)
	if (locale === "de") return de_admin_ai_chat_status_thinking(inputs)
	if (locale === "es") return es_admin_ai_chat_status_thinking(inputs)
	if (locale === "fr") return fr_admin_ai_chat_status_thinking(inputs)
	if (locale === "nl") return nl_admin_ai_chat_status_thinking(inputs)
	if (locale === "it") return it_admin_ai_chat_status_thinking(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_status_thinking(inputs)
	if (locale === "pl") return pl_admin_ai_chat_status_thinking(inputs)
	if (locale === "hu") return hu_admin_ai_chat_status_thinking(inputs)
	return ro_admin_ai_chat_status_thinking(inputs)
});
export { admin_ai_chat_status_thinking as "admin.ai_chat.status_thinking" }